import React from 'react'

const PaymentError = () => {
  return (
    <div>
      PaymentError
    </div>
  )
}

export default PaymentError
